import * as jsxRuntime from "C:\\Users\\LUIS MIGUEL\\Desktop\\FINTRACE\\fintrace-frontend\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment